import { TagColorVariant } from './Tag.enum';
const colorVariantToThemeColorMap = {
    [TagColorVariant.LIGHT_GREY]: 'interactiveSecondary01',
    [TagColorVariant.GREY]: 'interactiveSecondary02',
    [TagColorVariant.DARK_GREY]: 'interactiveSecondary03',
};
const handleTagBackground = (theme, variant = TagColorVariant.LIGHT_GREY) => theme.colors[colorVariantToThemeColorMap[variant]];
export default handleTagBackground;
//# sourceMappingURL=Tag.helpers.js.map